export class TrueTimeService {
  private static serverTimeAtLoad: number = Date.now();
  private static performanceAtLoad: number = performance.now();
  private static isInitialized = false;
  private static lastKnownInterval: any = null;

  public static async initialize(serverTimeIso?: string) {
    if (serverTimeIso) {
      this.serverTimeAtLoad = new Date(serverTimeIso).getTime();
      const offset = this.serverTimeAtLoad - Date.now();
      localStorage.setItem('true_time_offset', offset.toString());
      
      // If the server provides a time, it is the ultimate source of truth. 
      // Correct the last known time in case it was stuck in the future due to previous tampering.
      localStorage.setItem('last_known_true_time', this.serverTimeAtLoad.toString());
    } else {
      const storedOffset = localStorage.getItem('true_time_offset');
      if (storedOffset) {
        this.serverTimeAtLoad = Date.now() + parseInt(storedOffset, 10);
      } else {
        this.serverTimeAtLoad = Date.now(); // fallback
      }
    }
    this.performanceAtLoad = performance.now();
    this.isInitialized = true;
    
    this.startTracking();
  }

  private static startTracking() {
    if (this.lastKnownInterval) clearInterval(this.lastKnownInterval);
    this.lastKnownInterval = setInterval(() => {
      localStorage.setItem('last_known_true_time', this.getTrueTime().getTime().toString());
    }, 5000);
  }

  public static getTrueTime(): Date {
    let baseTime = Date.now();
    
    if (this.isInitialized) {
      const elapsed = performance.now() - this.performanceAtLoad;
      baseTime = this.serverTimeAtLoad + elapsed;
    } else {
      const storedOffset = localStorage.getItem('true_time_offset');
      if (storedOffset) {
        baseTime = Date.now() + parseInt(storedOffset, 10);
      }
      
      // Anti-tampering fallback: ONLY apply if offline and not initialized.
      // Prevent time from going backwards compared to last known time.
      const lastKnownStr = localStorage.getItem('last_known_true_time');
      if (lastKnownStr) {
        const lastKnown = parseInt(lastKnownStr, 10);
        if (baseTime < lastKnown) {
          console.log(`[TrueTimeService] Anti-tampering fallback: Backward time jump prevented. Overriding ${new Date(baseTime).toISOString()} with ${new Date(lastKnown).toISOString()}`);
          baseTime = lastKnown; 
        }
      }
    }

    console.log(`[TrueTimeService] getTrueTime returned: ${new Date(baseTime).toISOString()} (Initialized: ${this.isInitialized})`);
    return new Date(baseTime);
  }

  public static isTimeTampered(): boolean {
    const lastKnownStr = localStorage.getItem('last_known_true_time');
    if (!lastKnownStr) {
      console.log(`[TrueTimeService] No last known time found. Cannot verify tampering.`);
      return false;
    }

    let calculatedTime = Date.now();
    if (this.isInitialized) {
      // If initialized, it's immune to tampering
      console.log(`[TrueTimeService] isTimeTampered: False (Service is actively running and immune to tampering)`);
      return false; 
    } else {
      const storedOffset = localStorage.getItem('true_time_offset');
      if (storedOffset) {
        calculatedTime = Date.now() + parseInt(storedOffset, 10);
      }
    }

    const lastKnown = parseInt(lastKnownStr, 10);
    console.log(`[TrueTimeService] isTimeTampered Check -> Calculated Time: ${new Date(calculatedTime).toISOString()}, Last Known: ${new Date(lastKnown).toISOString()}`);
    
    // If calculated time is behind last known (backward tampering)
    if (calculatedTime < lastKnown) {
      console.log(`[TrueTimeService] Tampering DETECTED! Time went backward.`);
      return true;
    }
    
    // If it jumps forward more than 24 hours without an offset update, it's suspicious
    if (calculatedTime - lastKnown > 24 * 60 * 60 * 1000) {
       console.log(`[TrueTimeService] Tampering DETECTED! Time jumped forward significantly.`);
       return true;
    }

    console.log(`[TrueTimeService] isTimeTampered: False (Time is within normal drift)`);
    return false;
  }
}
